import { useState, type FormEvent } from "react";
import { Button, Card, FormField, Input } from "@/ui";
import { token } from "@/design/theme";

/**
 * LookupForm — the keyboard-first single-id lookup the three patient-portal screens share. Submit on
 * Enter (it is a real <form>); the field auto-focuses; the verdict/preview commits the entered id only
 * on submit (so the live probe never fires per keystroke). Mono field face for the id.
 */
export function LookupForm({
  label,
  hint,
  submitLabel,
  loading,
  onSubmit,
}: {
  label: string;
  hint: string;
  submitLabel: string;
  loading: boolean;
  /** Called with the trimmed id on submit (only when non-empty). */
  onSubmit: (id: string) => void;
}) {
  const [value, setValue] = useState("");
  const trimmed = value.trim();

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (trimmed === "") return;
    onSubmit(trimmed);
  };

  return (
    <Card style={{ maxWidth: 560 }}>
      <form onSubmit={submit} noValidate>
        <div style={{ display: "flex", flexDirection: "column", gap: token.s4 }}>
          <FormField label={label} hint={hint} required>
            {(p) => (
              <Input
                {...p}
                mono
                autoFocus
                inputMode="numeric"
                autoComplete="off"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            )}
          </FormField>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button type="submit" loading={loading} disabled={trimmed === ""}>
              {submitLabel}
            </Button>
          </div>
        </div>
      </form>
    </Card>
  );
}
